$(document).ready(function ($) {
    if(window.location.hash && !$('#main-dropdown').length) {
        if(window.location.hash === '#register-modal') {
            openRegisterModal();
        }
        else if(window.location.hash === '#sign-in-modal') {
            openSignInModal();
        }
        else if(window.location.hash === '#reset-password') {
            openResetPasswordModal();
        }
    }
    else if((window.location.pathname === $('#register_url').val() || window.location.pathname === $('#register_url').data('url')) && !$('#is_user_logged_in').val()) {
        openRegisterModal();
    }

    $(document).on('click', '.sign-in-btn', function (e) {
        e.preventDefault();
        openSignInModal();
    });

    $(document).on('click', '.sign-up-btn', function (e) {
        e.preventDefault();
        openRegisterModal();
    });

    $(document).on('click', '.apply-as-guest-btn', function (e) {
        e.preventDefault();
        /* Show Login section */
        $(".sign-up-wrapper").addClass("hide");
        /* Open popup  */
        $('#register').modal('show')
        // var lang = $(this).attr('data-lang');
        // var href = $(this).attr('data-url');

        // var companyId = $(this).attr('data-company-id');
        // var companyTitle = $(this).attr('data-company-title');
        // var jobAnnouncementId = $(this).attr('data-job-announcement-id');
        // var jobAnnouncementTitle = $(this).attr('data-job-announcement-title');

        // href = href + '?type=sign-in&company-id=' + companyId + '&company-title=' + companyTitle + '&job-announcement-id=' + jobAnnouncementId + '&job-announcement-title=' + jobAnnouncementTitle;

        // $('#register').modal('show')
        //     .find('#modal-content')
        //     .load(encodeURI(href));
    });

    $(document).on('click', '.open-sign-up-btn', function (e) {
        e.preventDefault();

        $(".sign-up-wrapper").addClass("hide");
        $(".sign-in-wrapper").removeClass("hide");
        $(".registration-social").removeClass("hide");
        $(".forgot-password-wrapper").addClass("hide");
        $(".forgot-password-content").removeClass("hide");
        $(".forgot-password-btn").removeClass("hide");
        $("#forgot-password-notification").addClass("hide");
    });

    $(document).on('click', '.open-sign-in-btn', function (e) {
        e.preventDefault();

        $(".sign-up-wrapper").removeClass("hide");
        $(".sign-in-wrapper").addClass("hide");
        $(".forgot-password-wrapper").addClass("hide");

    });

    $(document).on('click', '#forgot-password-btn', function (e) {
        e.preventDefault();

        $(".sign-up-wrapper").addClass("hide");
        $(".sign-in-wrapper").addClass("hide");
        $(".registration-social").addClass("hide");
        $(".forgot-password-wrapper").removeClass("hide");

    });

    $(document).on("beforeSubmit", "#forgot-password-form", function () {

        var email = $(this).find("#forgot_password_email").val();
        langUrl = $(this).find('.currentLanguageClass').val();
        $.ajax({
            type: "POST",
            url: '/' + langUrl + '/users/registration/forgot-password',
            data: {
                email: email
            },
            success: success,
            beforeSend: function () {
                $('.forgot-password-content').after(loader);
                $(".forgot-password-content").addClass("hide");
                $(".forgot-password-btn").addClass("hide");
            }
        });


        function success(data) {
            $(".user-email").text(email);
            $(".forgot-password-content").next(".bubblingG").remove();
            $("#forgot-password-notification").removeClass("hide");
        }

        return false;
    });

    var loader = '<div class="bubblingG"> <span id="bubblingG_1"> </span> <span id="bubblingG_2"> </span> <span id="bubblingG_3"> </span> </div>';

    $(document).on('click', '#search-btn', function (e) {
        var href = $(this).attr('data-url');

        $.get(href, function (data) {
            $('#search').modal('show')
                .find('#modal-content')
                .html(data);
        });

        e.preventDefault();
    });


    $(document).on('click', '#sign-up-now', function (e) {
        var href = $(this).attr('data-url');

        href = href + '?type=sign-up';

        $('.mail-check').hide();

        $.get(href, function (data) {
            $('#search').modal('show')
                .find('#modal-content')
                .html(data);
        });

        e.preventDefault();
    });

    $(document).on('click', '#sign-up-from-apply', function (e) {
        var href = $(this).attr('data-url');

        href = href + '?type=sign-up';

        $.get(href, function (data) {
            $('#search').modal('show')
                .find('#modal-content')
                .html(data);
        });

        e.preventDefault();
    });

    $(document).on('click', '.hide-apply-as-guest-success-popup', function (e) {
        $('.mail-check').hide();
    });


    $(document).on('click', '#apply-btn', function (e) {
        var id = $(this).attr('data-id');
        var url = $(this).attr('data-url');

        $.get(url, function (data) {
            $('#hs_default_modal').modal('show').find('.modal-body').html(data);
            // $('#hs_default_modal').modal('show')
            //     .find('#modalContent')
            //     .html(data);
        });

        e.preventDefault();
    });

    $(document).on('click', '#already-applied-btn', function (e) {
        var id = $(this).attr('data-id');
        var url = $(this).attr('data-url');

        $.get(url, function (data) {
            $('#modal').modal('show')
                .find('#modalContent')
                .html(data);
        });

        e.preventDefault();
    });


    $(document).on('click', '#not_enough_profile_completeness', function (e) {
        // var id = $(this).attr('data-id');
        var url = $(this).attr('data-url');

        $.get(url, function (data) {
            $('#modal1').modal('show')
                .find('#modalContent1')
                .html(data);
        });

        e.preventDefault();
    });


    function getURLParameter(name) {
        return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.search) || [null, ''])[1].replace(/\+/g, '%20')) || null;
    }

    var openPopUp = getURLParameter('type');

    if (openPopUp === "pop-up") {
        var lang = window.location.pathname.substr(1, 2);
        if (lang) {
            var href = "/" + lang + "/users/registration/sign-up";
        } else {
            var href = "/users/registration/sign-up";
        }


        href = href + '?type=sign-up';

        $.get(href, function (data) {
            $('#register').modal('show')
                .find('#modal-content')
                .html(data);
        });
    } else if (openPopUp === "sign-in") {
        var lang = window.location.pathname.substr(1, 2);
        if (lang) {
            var href = "/" + lang + "/users/registration/sign-in";
        } else {
            var href = "/users/registration/sign-in";
        }


        href = href + '?type=sign-in';

        $.get(href, function (data) {
            $('#register').modal('show')
                .find('#modal-content')
                .html(data);
        });
    }


    $('#login-form').on('afterValidate', function (event, message, attr) {

        if (attr.length != 0) {
            $('.loginBtn').find('.bubblingG').addClass('hide');
            $('#btn_login').removeClass('hide');

            if(message['loginform-wrong_login'] && message['loginform-wrong_login'].length) {
                var wrongLoginCount = message['loginform-wrong_login'][0];
                $('#wrong_login').val(wrongLoginCount)
                if(parseInt(wrongLoginCount) > 2 && $('#login_captcha_block').hasClass('hidden')) {
                    $('#login_captcha_block').removeClass('hidden')
                }
            }
        }
    });

    $('#order-form1').on('afterValidate', function (event, message, attr) {

        if (attr.length != 0) {
            $('.registration-submit-btn').find('.bubblingG').addClass('hide');
            $('#btn_register').removeClass('hide');
        }
    });

    $('#login-form').on('submit', function (event, message, attr) {
        $('#btn_login').addClass('hide');
        $('.loginBtn').find('.bubblingG').removeClass('hide');
        return true;
    });

    $('#order-form1').on('submit', function (event, message, attr) {
        if ($('#captcha_exists').val()) {
            $('#hiddenValidateInput').val(grecaptcha.getResponse(0));
        }
        $('#btn_register').addClass('hide');
        $('.registration-submit-btn').find('.bubblingG').removeClass('hide');
        return true;
    });

    $('#contact-form').on('submit', function (event, message, attr) {
        if ($('#captcha_exists').val()) {
            $('#hiddenValidateInputForContact').val(grecaptcha.getResponse(1));
        }
        return true;
    });

});

function openRegisterModal()
{
    $('.container').css('transform', '');
    $('.hc-offcanvas-nav').removeClass('nav-open');
    $('.collapse  .hc-nav-trigger').removeClass('toggle-open');

    $.get($('.sign-up-btn').attr('data-url'), function (data) {
        $('#register').modal('show')
            .find('#modal-content')
            .html(data);
        $('#register').find('.sign-in-wrapper').addClass('hide')
    });
}

function openSignInModal()
{
    $('.container').css('transform', '');
    $('.hc-offcanvas-nav').removeClass('nav-open');
    $('.collapse  .hc-nav-trigger').removeClass('toggle-open');

    $.get($('.sign-in-btn').attr('data-url'), function (data) {
        $('#register').modal('show')
            .find('#modal-content')
            .html(data);
        $('#register').find('.sign-up-wrapper').addClass('hide')
    });

}

function openResetPasswordModal()
{
    $.get($('#reset_pass_modal_url').val(), function (data) {
        $('#register').modal('show')
            .find('#modal-content')
            .html(data);
    });
}

